var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmileySad = function SvgSmileySad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 18.2c-4.6.8-7.7 4.7-9.5 8.8 0 .1.1.2.2.1C10.2 20 17.5 15.3 24.4 21c.1.1.3-.1.2-.2-2.1-2.3-5.5-3.2-8.5-2.6zM9 14.2c-.8-2.9-2.1-5.8-3.5-8.4-.1-.1-.2 0-.2.1 1.3 2.7 2.3 5.6 3.5 8.4 0 .1.2 0 .2-.1zM14.6 12.2c-.6-3-.9-6.3-2.1-9.1-.1-.1-.2 0-.2.1.7 3 1.4 6 2.2 9 0 .2.1.1.1 0z"
  })));
};
export default SvgSmileySad;